import { createContext, useContext, useMemo } from "react";
import { useLineMgmParams } from "./use-line-mgm-params";



const MgmContext = createContext(null);

export function useLineMgmContext() {
  const ctx = useContext(MgmContext);
  if (!ctx) {
    throw new Error('LineMgmProvider is missing in the tree');
  }

  return {
    isMounted: ctx.isMounted,
    customData: ctx.customData,
    isAction: ctx.isAction,
    isNewFriend: ctx.isNewFriend,
  };
}


export function LineMgmProvider(props) {
  const { children, debug = false } = props;
  const { customData, isAction, isNewFriend, isMounted } = useLineMgmParams({ debug });

  const value = useMemo(() => ({
    customData,
    isAction,
    isNewFriend,
    isMounted,
  }), [customData, isAction, isNewFriend, isMounted]);

  return (
    <MgmContext.Provider value={value}>
      {isMounted && children}
    </MgmContext.Provider>
  );
}
